







































import Vue from 'vue';
import store from '@/store';
import { Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import { Product } from '@/types/product';
import { Funder } from '@/types/funder';
import ProductListTile from '@/components/Product/ProductListTile.vue';
import _ from 'lodash';

@Component({
  components: { ProductListTile },
})
export default class ProductList extends Vue {
  @Action('products/getProducts') getProducts!: Function;
  @Action('funders/getFunderBySlug') getFunderBySlug!: Function;
  @Getter('products/products') products!: Product[];
  @Getter('products/totalProductPages') totalProductPages!: number;
  @Getter('products/currentProductPage') currentProductPage!: number;
  @Getter('funders/funder') funder!: Funder;
  @Prop() funderSlug!: string;
  @Prop() published!: boolean;

  get pageName() {
    if (this.funderSlug === undefined) {
      return _.startCase(this.$route.name);
    } else {
      return _.startCase(this.$route.name) + ' for ' + this.funder.name;
    }
  }

  get currentPage() {
    return this.currentProductPage;
  }

  set currentPage(page) {
    this.getProducts({ funder: this.funderSlug, page });
  }

  get filteredProducts(): Product[] {
    return _.filter(
      this.products,
      product => product.published === this.published,
    );
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    const funder: string | null =
      to.params.funder !== undefined ? to.params.funder : null;
    store.dispatch('funders/getFunderBySlug', funder);

    const page =
      funder !== from.params.funder ? 1 : store.getters.products.currentPage++;

    await Promise.all([
      store.dispatch('products/getProducts', { funder, page }),
    ]);
    next();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: Function) {
    const funder: string | null =
      to.params.funder !== undefined ? to.params.funder : null;
    store.dispatch('funders/getFunderBySlug', funder);

    const page =
      funder !== from.params.funder ? 1 : store.getters.products.currentPage++;

    await Promise.all([
      store.dispatch('products/getProducts', { funder, page }),
    ]);
    next();
  }
}
